import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { PatientService } from "../../../services/patient.service";
import { DownloadService } from "../../../services/download.service";
import { IDownloadEligibilityPayload } from "../../../services/patient.service";
export default defineComponent({
    inject: ["dialogRef"],


    data() {
        return {
            dialogReference: this.dialogRef as any,
            eligibilityData: {},
            _patientsService: null as PatientService,
            AgencyId:"",
            _downloadService: null

        };
    },

    async created() {
            this._patientsService = Container.instance.get(PatientService);
            this._downloadService = Container.instance.get(DownloadService);
    },

    async mounted() {
        Object.assign(this.eligibilityData, this.dialogReference.data.response);
    },

    methods: {
        cancel() {
            this.dialogReference.close("cancel");
        },
        async downloadEligibility() {
                    const payload:IDownloadEligibilityPayload =
                  {
                    PatientEligibility:{
                        "AgencyId": this.dialogReference.data.AgencyId,
                        ...this.dialogReference.data.response,
                    },
                    "AgencyId": this.dialogReference.data.AgencyId,
                  }

                    try {
                        let response = await this._patientsService.downloadEligibility(payload);
                        this._downloadService.downloadFile(response);
                    } catch (error) {
                        console.error(error);
                    }
                }
    }
});

